import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=566686c2&scoped=true&"
import script from "./Badges.vue?vue&type=script&lang=js&"
export * from "./Badges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566686c2",
  null
  
)

export default component.exports